import { ButtonAdd } from "components/buttons";
import { MprcCardFilterBox } from "components/filter/MprcCardFilterBox";
import { IconButtonBlocked } from "components/iconButtons";
import { IconFilter } from "components/icons";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { ManagedClassroomOrderByQuery } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { AdvancedFilter, IAdvFilterCommand } from "views/general/AdvancedFilter";
import { FilterCmd } from "views/general/AdvancedFilter/FilterCmd";
import { ClassroomListFilter, useClassroomManagementContext } from "views/lms/classroom/Home/ClassroomManagementWrapper";

interface IProps {
    onAdd: () => void;
}

export const Filter: React.FC<IProps> = (props) => {

    const { onAdd } = props;
    const { t } = useTranslation("lms");

    const ctx = useClassroomManagementContext();

    ///
    const handleFilter = (data: Partial<ClassroomListFilter>) => {
        ctx.setFilter(data);
        ctx.setPagination({ page: 1 });
    };

    ///
    const dropdownOptions = (): IAdvFilterCommand[] => {
        var options: IAdvFilterCommand[] = [
            FilterCmd.Classroom.classroomInstructor(1),
            FilterCmd.Classroom.classroomNameContain(2),
            FilterCmd.Classroom.classroomExternalCodeContain(2),

            FilterCmd.Classroom.classroomUsersInProgress(3),
            FilterCmd.Classroom.classroomWithOpenEnrollment(3),
            FilterCmd.Classroom.classroomWithAudience(3),
            FilterCmd.Classroom.classroomExpired(3),

            FilterCmd.Classroom.classroomCreatedOn(4),
            FilterCmd.Classroom.classroomModifiedOn(4),

            FilterCmd.Classroom.classroomCreatedByYou(5),
            FilterCmd.Classroom.classroomCreatedByUser(5),
        ];

        return options;
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcCardFilterBox>
            <AdvancedFilter
                filter={ctx.filter}
                leftDropdowns={[{
                    filterCommands: dropdownOptions(),
                    textOrIcon: <IconFilter />,
                    title: t("shared:AdvFilter.Title")
                }]}
                leftDropdownAlign="end"
                orderMenuOptions={[
                    { text: t("Classroom.List.OrderBy.NameText"), value: ManagedClassroomOrderByQuery.Name, group: 1 },
                    { text: t("Classroom.List.OrderBy.MostRecentText"), value: ManagedClassroomOrderByQuery.MostRecent, group: 1 },
                    { text: t("Classroom.List.OrderBy.MoreEnrollmentsText"), value: ManagedClassroomOrderByQuery.MoreEnrollment, group: 1 },
                ]}
                startComponent={
                    <ButtonAdd
                        size="large"
                        color="inherit"
                        onClick={onAdd}
                        text={t("Classroom.List.NewClassroomButtonText")}
                    />
                }
                beforeLeftDropdown={
                    [
                        <IconButtonBlocked
                            color={!ctx.filter.onlyActive ? "warning" : "inherit"}
                            onClick={() => handleFilter({ onlyActive: !ctx.filter.onlyActive })}
                            title={t("shared:Actions.ListInactive")}
                        />
                    ]
                }
                onFilterChange={(filter) => {
                    ctx.setPagination({ page: 1 });
                    ctx.setFilter({ ...ctx.filter, ...filter });
                }}
                onError={error => MprcRequestSnackbarErrorReport(error)}
            />
        </MprcCardFilterBox>
    );
};
